import { useParams } from 'react-router-dom';
import { useAuthenticationProvider } from 'infrastructure/security/authentication/AuthenticationProvider';
import { useIsMyProfile } from './useIsMyProfile';

export const useEmployeeId = () => {
  const isMyProfile = useIsMyProfile();

  const urlId = useParams<Dictionary<string>>().id!;
  const { getUserAlias } = useAuthenticationProvider();
  const userAlias = getUserAlias();

  return isMyProfile ? userAlias : urlId;
};
